<script>
  import "../node_modules/materialize-css/dist/css/materialize.min.css";
  import "../node_modules/materialize-css/dist/js/materialize.js";
  import Timer from "./Timer.svelte";
  import dayjs from 'dayjs';
  import { onMount } from 'svelte';
  const STATUS = {
    SETTING: 1,
    TIMER: 2
  }

  const TIMERS = {
    HOUR: 1,
    DAY: 2,
    MONTH: 3,
    YEAR: 4,
    CENTURY: 5,
    SECOND: 6,
  };
  const SETTING_BTN_CLASS = "waves-effect waves-light btn";

  let status = -1;
  let timerSetting = -1;
  let targetTime = -1;
  let targetSecond = -1;
  let hour = -1;
  let minute = -1;
  let second = -1;
  let progress = -1;
  let isProcessing = false;

  const about = () => {
    alert("ポモドーロテクニック(25分単位で作業に区切りをつける)用のタイマーのクソデカバージョンです。生産性は多分落ちます。ご了承ください。");
  };

  const selectTimer = (timerType) => {
    timerSetting = timerType;
  };

  const start = () => {
    if(timerSetting < 1){
      alert("タイマー設定を選択してください。");
      return;
    }

    const setParams = () => {
      targetTime = calcTargetTime(timerSetting);
      targetSecond = dayjs.unix(targetTime).diff(dayjs(),"second");
      localStorage.setItem('targetTimestamp', targetTime);
      localStorage.setItem('targetSecond', targetSecond);
      status = STATUS.TIMER;
      isProcessing = true;
    };

    // 通知許可ダイアログ表示
    try {
      Notification.requestPermission().then(permission => {
        setParams();
      });
    } catch (error) {
      setParams();
    }
  };

  const calcTargetTime = (timer) => {
    let target = dayjs();
    switch(timer){
      case TIMERS.HOUR:
        target = target.add(25,"h");
        break;
      case TIMERS.DAY:
        target = target.add(25,"day");
        break;
      case TIMERS.MONTH:
        target = target.add(25,"month");
        break;
      case TIMERS.YEAR:
        target = target.add(25,"year");
        break;
      case TIMERS.CENTURY:
        target = target.add(2500,"year");
        break;
      case TIMERS.SECOND:
        target = target.add(25,"second");
        break;
      default:
        break;
    }
    return target.add(1,"second").unix();
  };

  setInterval(() => {
    if(!isProcessing){
      return;
    }
    const now = dayjs();
    const target = dayjs.unix(targetTime);
    hour = target.diff(now,"hour");
    minute = zeroPadding(target.diff(now,"minute") % 60,2);
    second = zeroPadding(target.diff(now,"second") % 60,2);
    const hourDiff = target.diff(now,"second");
    progress = (targetSecond - hourDiff) / targetSecond;
    if(progress >= 1 && isProcessing){
      isProcessing = false;
      setTimeout(() =>{
        const endMessage = "終了時間になりました。休憩しましょう！";
        try {
          if (Notification.permission === 'granted') {
            navigator.serviceWorker.ready.then(registration => {
              registration.active.postMessage(endMessage);
              stop();
            });
            return;
          }
          alert(endMessage);
          stop();
        } catch (err) {
          alert(endMessage);
          stop();
        }
      },1000);
    }
  },100);

  const stop = () => {
    status = STATUS.SETTING;
    localStorage.removeItem("targetTimestamp");
    localStorage.removeItem("targetSecond");
    targetTime = -1;
    targetSecond = -1;
    timerSetting = -1;
    isProcessing = false;
  };

  const zeroPadding = (num, len) => {
	  return ( Array(len).join('0') + num ).slice( -len );
  }

  onMount(async () => {
    const target = Number(localStorage.getItem("targetTimestamp"));
    if(target){
      const now = dayjs().unix();
      if(now >= target){
        stop();
        alert("終了時間を超過しています。休憩しましょう！");
        return;
      }
      targetSecond = Number(localStorage.getItem("targetSecond"));
      status = STATUS.TIMER;
      targetTime = target;
      isProcessing = true;
      return;
    }
    status = STATUS.SETTING;
	});
</script>

<main class="wrapper">
  <header class="header z-depth-2">
    <span class="title">クソデカポモドーロタイマー</span>
    <div>
      <button class="waves-effect waves-light btn-small" on:click="{about}">何これ</button>
    </div>
  </header>
  <div class={`main ${status === STATUS.SETTING ? "" : "hidden"}`}>
    <p class="lbl">タイマー設定</p>
    <div class="settings">
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.SECOND === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.SECOND)}">25秒</button>
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.HOUR === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.HOUR)}">25時間</button>
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.DAY === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.DAY)}">25日間</button>
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.MONTH === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.MONTH)}">25ヶ月</button>
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.YEAR === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.YEAR)}">25年間</button>
      <button class={`${SETTING_BTN_CLASS} ${TIMERS.CENTURY === timerSetting ? "blue darken-1" : "red lighten-1"}`} on:click="{() => selectTimer(TIMERS.CENTURY)}">25世紀</button>
    </div>
    <div class="start">
      <button class="waves-effect waves-light btn cyan darken-2" on:click="{start}">開始</button>
    </div>
  </div>
  <div class={`main ${status === STATUS.TIMER ? "" : "hidden"}`}>
    <p class="lbl">残り時間</p>
    <Timer hour={hour} minute={minute} second={second} progress={progress} stop={stop}></Timer>
  </div>
  <footer class="footer z-depth-1">
    <span>作った人：<a href="https://twitter.com/de_teiu_tkg" target="_blank" rel="noopener">@de_teiu_tkg</a></span>
  </footer>
</main>
<style>
  .header {
    height: 40px;
    line-height: 40px;
    background-color: aliceblue;
    padding: 0px 5px;
    display: flex;
    justify-content: space-between;
    z-index: 99999;
  }

  .title {
    font-size: 1.3rem;
    font-weight: bold;
  }

  .footer {
    height:28px;
    line-height: 28px;
    background-color: aliceblue;
    padding: 0px 5px;
    z-index: 99999;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    background-color: rgb(255,235,235);
    display: flex;
    flex-direction: column;
  }

  .main {
    flex-grow: 1;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .lbl {
    text-align: center;
    font-size: 1.5rem;
    margin:0px 0px;
    margin-top: 5px;
  }

  .settings {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  .settings > .btn {
    width: 29.5vw;
    height: 29.5vw;
    max-width: 130px;
    max-height: 130px;
    font-size: 1.8rem;
    margin: 4px 4px;
    padding: 0px;
  }

  .start {
    width: 100%;
    display: flex;
    padding: 10px;
    padding-top: 5px;
  }
  .start .btn {
    flex-grow: 1;
    font-size: 2.0rem;
    height: 48px;
  }

  .hidden {
    display: none !important;
  }
</style>